import React from 'react';
import { validated } from 'react-custom-validation'
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import clone from 'clone';

import {handleMultiSelectChange, handleSelectChange, handleTextChange} from 'utils/handle-changes';
import { isEmail, isRequired, isRequiredIfTrue } from 'utils/validations';

import AvatarUpload from 'components/AvatarUpload/index';
import Button from 'components/Button/index';
import Dropdown from 'components/Dropdown/index';
import Form from 'components/Form/index';
import FormColumn from 'components/FormColumn/index';
import FormRow from 'components/FormRow/index';
import FormValidationMessage from 'components/FormValidationMessage/index';
import H3 from 'components/H3/index';
import LoadingCircle from 'components/LoadingCircle/index';
import Textbox from 'components/Textbox/index';

class FreelancerAccountForm extends React.Component {
    static propTypes = {
        adminView: PropTypes.bool.isRequired,
        avatarError: PropTypes.object.isRequired,
        error: PropTypes.object.isRequired,
        industryExperienceTypes: PropTypes.array.isRequired,
        isSaving: PropTypes.bool.isRequired,
        isSavingAvatar: PropTypes.bool.isRequired,
        locations: PropTypes.array.isRequired,
        onInvalid: PropTypes.func.isRequired,
        onValid: PropTypes.func.isRequired,
        setUser: PropTypes.func.isRequired,
        skills: PropTypes.array.isRequired,
        specialties: PropTypes.array.isRequired,
        uploadAvatar: PropTypes.func.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();

        this.state = {
            originalUser: {}
        };
    }

    componentDidMount() {
        this.setState({originalUser: clone(this.props.user)});
    }

    _handleChange(name, value) {

        if(['linkedIn', 'dribbble', 'twitter', 'facebook', 'instagram', 'github'].indexOf(name) !== -1) {
            value = value.replace('https://', '');
            value = value.replace('http://', '');
        }
        let newUserObj = update(this.props.user, {});
        newUserObj[name] = value;
        this.props.setUser(newUserObj);
    }

    _handleAvatarSelect(files) {
        this._handleChange('profilePicUrl', files[0]);
        this.props.uploadAvatar();
    }

    render() {
        let { adminView, avatarError, error, isSaving, onInvalid, onValid, user, $field, $validation } = this.props;

        if(Object.keys(user).length === 0 && adminView !== true) {
            return (
                <LoadingCircle />
            );
        } else {
            return (
                <Form className="freelancer-account-form">
                    {user.company == null && adminView !== true ? (
                        <FormRow className="freelancer-account-form__avatar-upload--wrapper">
                            <AvatarUpload
                                avatar={user.profilePicUrl}
                                className="freelancer-account-form__avatar-upload"
                                handleAvatarSelect={this._handleAvatarSelect.bind(this)}
                                isSaving={this.props.isSavingAvatar === true}
                            />
                            {Object.keys(avatarError).length > 0 ? (
                                <FormValidationMessage>
                                    {avatarError.friendlyMessage || avatarError.message}
                                </FormValidationMessage>
                            ) : null}
                        </FormRow>
                    ) : null}

                    <FormRow columnCount={2}>
                        <FormColumn>
                            <H3>
                                Basic Information
                            </H3>

                            <FormRow>
                                <Textbox
                                    id="txtFirstName"
                                    label="First Name"
                                    name="firstName"
                                    required
                                    type="text"
                                    validation={$validation.firstName}
                                    value={user.firstName || ''}
                                    {...$field('firstName', (event) => handleTextChange(this._handleChange.bind(this), event))}
                                />
                            </FormRow>

                            <FormRow>
                                <Textbox
                                    id="txtLastName"
                                    label="Last Name"
                                    name="lastName"
                                    required
                                    type="text"
                                    validation={$validation.lastName}
                                    value={user.lastName || ''}
                                    {...$field('lastName', (event) => handleTextChange(this._handleChange.bind(this), event))}
                                />
                            </FormRow>

                            {user.company == null || user.isAdmin === true ? (
                                <div>
                                    <FormRow>
                                        <Dropdown
                                            id="selPrimarySpecialization"
                                            label="Primary Role / Position"
                                            labelKey="name"
                                            name="primarySpecialization"
                                            onChange={(selectedValue) => handleSelectChange(this._handleChange.bind(this), 'primarySpecialization', null, this.props.$fieldEvent, selectedValue, true)}
                                            options={this.props.specialties}
                                            required={user.isAdmin !== true}
                                            simpleValue={false}
                                            validation={$validation.specializations}
                                            value={user.primarySpecialization}
                                            valueKey="id"
                                        />
                                    </FormRow>

                                    <FormRow>
                                        <Dropdown
                                            id="selSecondarySpecialization"
                                            label="Secondary Role / Position"
                                            labelKey="name"
                                            name="secondarySpecialization"
                                            onChange={(selectedValue) => handleSelectChange(this._handleChange.bind(this), 'secondarySpecialization', null, this.props.$fieldEvent, selectedValue, true)}
                                            options={this.props.specialties}
                                            simpleValue={false}
                                            value={user.secondarySpecialization}
                                            valueKey="id"
                                        />
                                    </FormRow>

                                    <FormRow>
                                        <Textbox
                                            id="txtAbout"
                                            label="About"
                                            name="description"
                                            type="textarea"
                                            onChange={(event) => handleTextChange(this._handleChange.bind(this), event)}
                                            value={user.description || ''}
                                        />
                                    </FormRow>

                                    <FormRow>
                                        <Textbox
                                            id="txtYearsExperience"
                                            label="Years Experience"
                                            name="experienceYears"
                                            onChange={(event) => handleTextChange(this._handleChange.bind(this), event)}
                                            type="number"
                                            value={user.experienceYears || ''}
                                        />
                                    </FormRow>

                                    {/*<FormRow>
                                        <Dropdown
                                            id="selSkills"
                                            label="Skills"
                                            labelKey="name"
                                            name="skills"
                                            onChange={handleSelectChange.bind(this, this._handleChange.bind(this), 'skills', null, null)}
                                            options={[{label: 'Test 1', value: 1}, {label: 'Test 2', value: 1}]}
                                            value={user.skills || ''}
                                            valueKey="id"
                                        />
                                    </FormRow>*/}

                                    <FormRow>
                                        <Dropdown
                                            closeOnSelect={false}
                                            id="selIndustryExperience"
                                            label="Industry Experience"
                                            labelKey="name"
                                            multi={true}
                                            name="industryExperiences"
                                            onChange={handleMultiSelectChange.bind(this, this._handleChange.bind(this), 'industryExperiences', null, null)}
                                            options={this.props.industryExperienceTypes}
                                            simpleValue={false}
                                            value={user.industryExperiences}
                                            valueKey="id"
                                        />
                                    </FormRow>

                                    <FormRow>
                                        <Textbox
                                            id="txtBrandExperience"
                                            label="Brand Experience"
                                            name="brandExperience"
                                            type="textarea"
                                            onChange={(event) => handleTextChange(this._handleChange.bind(this), event)}
                                            value={user.brandExperience || ''}
                                        />
                                    </FormRow>
                                </div>
                            ) : null}

                        </FormColumn>

                        <FormColumn>
                            <H3>
                                Contact Information
                            </H3>

                            <FormRow>
                                <Textbox
                                    id="txtEmail"
                                    label="Email"
                                    name="email"
                                    required
                                    type="email"
                                    validation={$validation.email}
                                    value={user.email || ''}
                                    {...$field('email', (event) => handleTextChange(this._handleChange.bind(this), event))}
                                />
                            </FormRow>

                            {adminView === true ? (
                                <FormRow>
                                    <Textbox
                                        id="txtPassword"
                                        label="Password"
                                        name="password"
                                        required
                                        type="password"
                                        validation={$validation.password}
                                        value={user.password || ''}
                                        {...$field('password', (event) => handleTextChange(this._handleChange.bind(this), event))}
                                    />
                                </FormRow>
                            ) : null}

                            {user.company == null || user.isAdmin === true ? (
                                <div>
                                    <FormRow>
                                        <Textbox
                                            id="txtPhone"
                                            label="Phone"
                                            name="phoneNumber"
                                            type="text"
                                            onChange={(event) => handleTextChange(this._handleChange.bind(this), event)}
                                            value={user.phoneNumber || ''}
                                        />
                                    </FormRow>

                                    <FormRow>
                                        <Textbox
                                            id="txtWebsite"
                                            label="Websites"
                                            name="website"
                                            type="text"
                                            onChange={(event) => handleTextChange(this._handleChange.bind(this), event)}
                                            value={user.website || ''}
                                        />
                                        <div className="c-form__instructions">
                                            A comma-separated list of fully-formed URLs.<br />
                                            ex: http://example.com,https://google.com
                                        </div>
                                    </FormRow>

                                    <FormRow>
                                        <Textbox
                                            id="txtLinkedIn"
                                            className="a-textbox--link"
                                            label="LinkedIn"
                                            name="linkedIn"
                                            type="text"
                                            onChange={(event) => handleTextChange(this._handleChange.bind(this), event)}
                                            value={user.linkedIn || ''}
                                        />
                                    </FormRow>

                                    <FormRow>
                                        <Textbox
                                            id="txtDribbble"
                                            className="a-textbox--link"
                                            label="Dribbble"
                                            name="dribbble"
                                            type="text"
                                            onChange={(event) => handleTextChange(this._handleChange.bind(this), event)}
                                            value={user.dribbble || ''}
                                        />
                                    </FormRow>

                                    <FormRow>
                                        <Textbox
                                            id="txtTwitter"
                                            className="a-textbox--link"
                                            label="Twitter"
                                            name="twitter"
                                            type="text"
                                            onChange={(event) => handleTextChange(this._handleChange.bind(this), event)}
                                            value={user.twitter || ''}
                                        />
                                    </FormRow>

                                    <FormRow>
                                        <Textbox
                                            id="txtFacebook"
                                            className="a-textbox--link"
                                            label="Facebook"
                                            name="facebook"
                                            type="text"
                                            onChange={(event) => handleTextChange(this._handleChange.bind(this), event)}
                                            value={user.facebook || ''}
                                        />
                                    </FormRow>

                                    <FormRow>
                                        <Textbox
                                            id="txtIntagram"
                                            className="a-textbox--link"
                                            label="Instagram"
                                            name="instagram"
                                            type="text"
                                            onChange={(event) => handleTextChange(this._handleChange.bind(this), event)}
                                            value={user.instagram || ''}
                                        />
                                    </FormRow>

                                    <FormRow>
                                        <Textbox
                                            id="txtGithub"
                                            className="a-textbox--link"
                                            label="Github"
                                            name="github"
                                            type="text"
                                            onChange={(event) => handleTextChange(this._handleChange.bind(this), event)}
                                            value={user.github || ''}
                                        />
                                    </FormRow>
                                </div>
                            ) : null}

                        </FormColumn>
                    </FormRow>

                    {Object.keys(error).length > 0 ? (
                        <FormRow className="error-message">
                            <FormValidationMessage>
                                {error.friendlyMessage || error.message}
                            </FormValidationMessage>
                        </FormRow>
                    ) : null}

                    <FormRow className="button-wrapper">
                        <Button className="freelancer-account-form__save-button"
                                disabled={isSaving === true}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.props.$submit(onValid, onInvalid);
                                }}
                                type="submit">
                            {adminView !== true ? 'Update' : 'Create'}
                            {isSaving === true ? <LoadingCircle innerColor="#ffffff" outerColor="#ffffff"/> : null}
                        </Button>

                        {adminView !== true && (
                            <Button
                                disabled={isSaving}
                                noStyles
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.props.$submit(() => onValid(true), onInvalid);
                                }}
                            >
                                Update & Preview
                            </Button>
                        )}

                    </FormRow>
                </Form>
            );
        }
    }
}

function freelancerAccountFormValidationConfig(props) {
    const { company, email, firstName, isAdmin, lastName, password, primarySpecialization } = props.user;

    return {
        fields: ['email', 'firstName', 'lastName', 'password', 'specializations'],
        validations: {
            email: [
                [isRequired, email],
                [isEmail, email]
            ],
            firstName: [
                [isRequired, firstName]
            ],
            lastName: [
                [isRequired, lastName]
            ],
            password: [
                [isRequiredIfTrue, props.adminView, password]
            ],
            specializations: [
                [isRequiredIfTrue, primarySpecialization, isAdmin !== true && company == null]
            ]
        }
    }
}

export default FreelancerAccountForm = validated(freelancerAccountFormValidationConfig)(FreelancerAccountForm);



// WEBPACK FOOTER //
// ./src/containers/Accounts/Edit/FreelancerAccountForm.js